import { forwardRef, useCallback } from 'react';

import type { InputProps } from 'atp-react-ui';
import { FormControl, FormItem, FormMessage, Input, Label } from 'atp-react-ui';
import type { NumericFormatProps } from 'react-number-format';
import { NumericFormat } from 'react-number-format';

type Props = NumericFormatProps<InputProps> & {
  formItemClassName?: string;
  hideMsg?: boolean;
  label: string;
  rightSlot?: React.ReactNode;
};

export const FormNumberInput = forwardRef<HTMLInputElement, Props>(
  ({ formItemClassName, onValueChange, label, value, hideMsg = false, rightSlot = null, ...props }, ref) => {
    const changeHandler = useCallback<Required<NumericFormatProps>['onValueChange']>(
      (s, source) => {
        if (s.value !== value && !props.disabled) {
          onValueChange?.(s, source);
        }
      },
      [onValueChange, props.disabled, value]
    );

    return (
      <FormItem className={formItemClassName}>
        <Label htmlFor={props.id} className="text-accent-light">
          {label}
        </Label>
        <FormControl>
          <NumericFormat {...props} value={value} onValueChange={changeHandler} customInput={Input} getInputRef={ref} />
        </FormControl>
        {rightSlot}
        {!hideMsg && <FormMessage />}
      </FormItem>
    );
  }
);

FormNumberInput.displayName = 'FormNumberInput';
